<template>
  <div>
    <label
      class="block text-xs mb-2"
      for="phone-number"
      v-text="'Mobile Number'"
    />
    <VuePhoneNumberInput
      id="phone-number"
      v-model="phoneNumber"
      color="#064bc3"
      class="mb-4"
      :translations="{ phoneNumberLabel: 'Mobile Number' }"
      default-country-code="US"
      no-flags
      no-validator-state
      @update="handlePhoneUpdate"
    />
    <span
      v-if="errors.has('phone_number')"
      class="help-block mb-1"
      v-text="errors.get('phone_number')"
    />
  </div>
</template>

<script type="text/babel">
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

export default {
  name: 'ProfilePhoneNumberField',
  components: {
    VuePhoneNumberInput,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  computed: {
    phoneNumber: {
      get() {
        return this.value.phone_number
      },
      set(value) {
        this.emit({ phone_number: value })
      },
    },
  },
  methods: {
    async handlePhoneUpdate(data) {
      await this.$nextTick()

      this.emit({ phone_number_country: data.countryCode })
    },
    emit(data) {
      this.$emit('input', {
        ...{
          phone_number: this.value.phone_number,
          phone_number_country: this.value.phone_number_country,
        },
        ...data,
      })
    },
  },
}
</script>
